import { Dispatch } from 'redux';
import { FormikActions } from 'formik';
import { push, replace } from 'connected-react-router';
import { AxiosResponse, AxiosRequestConfig, AxiosError } from 'axios';

import { ICustomer } from '../../@types';
import axios from '../../common/axios-instance/axios-instance';
import { ICustomerFormValues } from '../../features/customer-entry/customer-entry';

import * as constants from './constants';
import { handleError } from '../utils';

export interface IUpdateCustomer {
  type: constants.UPDATE_CUSTOMER;
  payload: ICustomer;
}

export interface IClearCustomer {
  type: constants.CLEAR_CUSTOMER;
}

export type CustomerAction = IUpdateCustomer | IClearCustomer;

export const getCustomer = (id: number) => {
  return (dispatch: Dispatch<IUpdateCustomer>) => {
    return axios
      .get<ICustomer>('/api/customer?id=' + id)
      .then((res: AxiosResponse<ICustomer>) => {
        return dispatch(updateCustomer(res.data));
      })
      .catch(handleError);
  };
};

export const updateCustomer = (customer: ICustomer): IUpdateCustomer => {
  return {
    type: constants.UPDATE_CUSTOMER,
    payload: customer
  };
};

export const clearCustomer = (): IClearCustomer => {
  return {
    type: constants.CLEAR_CUSTOMER
  };
};

export const submitCustomer = (
  customer: ICustomer,
  onSuccessfulSubmit: (customer: ICustomer) => void,
  { setSubmitting }: FormikActions<ICustomerFormValues>
) => {
  return (dispatch: Dispatch) => {
    const axiosRequest: AxiosRequestConfig = {
      method: !customer.id ? 'post' : 'put',
      url: '/api/customer',
      data: customer
    };

    return axios(axiosRequest)
      .then((res: AxiosResponse<ICustomer>) => {
        onSuccessfulSubmit(res.data);
        setSubmitting(false);
        if (!customer.id) {
          dispatch(replace('/customers/view/' + res.data.id));
        }
      })
      .catch((error: AxiosError) => {
        console.log(error);
        setSubmitting(false);
      });
  };
};

export const deleteCustomer = (id: number) => {
  return (dispatch: Dispatch) => {
    return axios
      .post<ICustomer>('/api/customer/delete', { id })
      .then(() => {
        return dispatch(clearCustomer());
      })
      .then(() => {
        return dispatch(push('/customers'));
      })
      .catch(handleError);
  };
};



// WEBPACK FOOTER //
// ./src/modules/customer/action.ts